export default __webpack_public_path__ + "static/media/E5.ecefd57a.mp3";